import { CliplisterResponse,CliplisterSearchResponse } from "../typings";

export default class Client {
  private CLIPLISTER_HOST = 'https://api-rs.mycliplister.com/v2.3/apis/asset';
  token: string;

  constructor(token: string) {
    if (!token) {
      throw new Error('You must provide an Cliplister token!');
    }

    this.token = token;
  }

  public async search(value: string, filter: string): Promise<CliplisterSearchResponse> {
    var appendFilter = ""; 
    switch (filter){
      case "picture":
        appendFilter = "(type%3D%3Dpicture)";
        break;
      case "video":
        appendFilter = "(type%3D%3Dvideo)";
        break;
      case "pdf":
        appendFilter = "(extension%3D%3Dpdf)";
        break;
      case "3d":
        appendFilter = "(kind%3D%3D3Dasset)";
        break;
      case "audio":
        appendFilter = "(extension%3D%3Dmp3)";
        break;
      case "template":
        appendFilter = "(kind%3D%3Dtemplate)";
        break;
      default:
        appendFilter = "(type%3D%3Dvideo,extension%3D%3Dpdf,extension%3D%3Dmp3,type%3D%3Ddocument,type%3D%3Dmiscellaneous,type%3D%3Dpicture,kind%3D%3Dtemplate,kind%3D%3D3Dasset)";
    }

    const res = await fetch(
      `${this.CLIPLISTER_HOST}/list?fiqlc=(filename%3D%3D%2A${value}%2A,title%3D%3D%2A${value}%2A,keywordtitle%3D%3D%2A${value}%2A);${appendFilter}&include_amount=true&include_directories=true&status=free`,
      //&fiqlc=type%3D%3Dvideo,type%3D%3Dpicture,kind%3D%3Dtemplate,kind%3D%3D3Dasset&
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }
    );

    if (res.ok) {
      const data: CliplisterResponse = await res.json();
      return {
        error: false,
        photos: data.assets,
        singleAsset: []
      };
    }

    return {
      error: true,
      photos: [],
      singleAsset: []
    };
  }
  public async getAssetDetails(uniqueId: string): Promise<CliplisterSearchResponse> {
    const res = await fetch(
      `${this.CLIPLISTER_HOST}/list?unique_id=${uniqueId}`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }
    );
  
    if (res.ok) {
      let data = []; 
      data = await res.json();

      return {
        error: false,
        // @ts-ignore
        singleAsset: data,
        photos: []
      };
    }
  
    return {
      error: true,
      photos: [],
      singleAsset: []
    };
  }
}
